import React from "react";
import stechlogo from "../../assets/stech.png";
import { NavLink, Link } from "react-router-dom";
import { BiHomeAlt } from "react-icons/bi";
import { ImProfile, ImCross } from "react-icons/im";
import {
  AiOutlinePlusCircle,
  AiOutlineBars,
  AiOutlineShopping,
} from "react-icons/ai";
import { Divider } from "@mui/material";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import { MyContextSupply } from "../../Context";

const SmallScreenSidebar = () => {
  const { isAdminSidebarOpen, setIsAdminSidebarOpen, toggleRunPath } =
    MyContextSupply();
  const CloseSidebar = () => {
    const tim = setTimeout(() => {
      setIsAdminSidebarOpen(false);
    }, 200);
    return () => {
      clearTimeout(tim);
    };
  };
  return (
    <section
      className={`smallScreenSidebar ${
        isAdminSidebarOpen && " showSmallScreenSidebar"
      }`}
    >
      <article
        className={`smallSideBar ${
          isAdminSidebarOpen ? "showSmallSideBar" : ""
        }`}
      >
        <div
          style={{
            background: "white",
            height: "75px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "10px",
          }}
        >
          <Link to="/" onClick={toggleRunPath}>
            <img
              src={stechlogo}
              alt=""
              className="admin-panel-logo smallScreenLogo"
            />
          </Link>
          <button
            onClick={() => setIsAdminSidebarOpen(false)}
            className="smallsidebar-close-btn"
          >
            <ImCross />
          </button>
        </div>
        <div className="navlikns-admin-panal">
          <NavLink
            onClick={() => {
              toggleRunPath();
              CloseSidebar();
            }}
            to="/admin"
            className="admin-panal-links"
          >
            <BiHomeAlt />
            Dashboard
          </NavLink>
          <h3 className="admin-sidebar-titles admin-sidebar-titles-others">
            Product Management
          </h3>
          <NavLink
            onClick={() => {
              toggleRunPath();
              CloseSidebar();
            }}
            to="/add/product"
            className="admin-panal-links"
          >
            <AiOutlinePlusCircle />
            Add Product
          </NavLink>
          <Divider />
          <NavLink
            onClick={() => {
              toggleRunPath();
              CloseSidebar();
            }}
            to="/product/list"
            className="admin-panal-links"
          >
            <AiOutlineBars />
            Product List
          </NavLink>
          <h3 className="admin-sidebar-titles admin-sidebar-titles-others">
            All Orders
          </h3>
          <NavLink
            onClick={() => {
              toggleRunPath();
              CloseSidebar();
            }}
            to="/recent/orders"
            className="admin-panal-links"
          >
            <AiOutlineShopping />
            Orders
          </NavLink>
          <Divider />
          <h3 className="admin-sidebar-titles">Personal Navigation</h3>
          <NavLink
            to="/"
            onClick={() => {
              toggleRunPath();
              CloseSidebar();
            }}
            className="admin-panal-links"
          >
            <BiHomeAlt />
            Home
          </NavLink>
          <Divider />
          <NavLink
            onClick={() => {
              toggleRunPath();
              CloseSidebar();
            }}
            to="/personalinfo"
            className="admin-panal-links"
          >
            <ImProfile />
            Profile
          </NavLink>
        </div>
      </article>
    </section>
  );
};

export default SmallScreenSidebar;
